import { ContextBase, StateTransitionData, StateTypes } from "@ortho-next/nextray-core";
import { Loading } from "./Loading";
import { RPM } from "./RPM";
import { Actions, State } from "./State";

/**
 * Events dispatcher to execute events logic inside contextInit.
 */
export class Context extends ContextBase<Actions> {
	protected declare _state: State;

	protected changeState(state: StateTransitionData): State {
		switch (state.type) {
			case StateTypes.loading:
				return new Loading(this);
			case StateTypes.RPM:
				return new RPM(this, state.data.caseModel, state.data.restore);
		}
		return this._state;
	}

	constructor() {
		super();
		this._state = new Loading(this);
	}
}
